/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#notAllowedMessage[_ngcontent-%COMP%]{position:absolute;width:500px;left:50%;color:#6e767d;margin-left:-250px;font-size:1.8em;text-align:center}"];
export { styles as styles };
